import { FeatureFlagIdNewNav2026 } from 'c1gen/features'
import { useFeatureChecker } from 'components/no-ui/capability'
import { FC } from 'react'

import { C1AppBar } from './C1AppBar'

export const AppBarWrapper: FC = () => {
    const hasNewNav = useFeatureChecker(FeatureFlagIdNewNav2026)

    // Don't show the old app bar when new nav is enabled
    if (hasNewNav) {
        return null
    }

    return <C1AppBar />
}
